import { get, post, put, del } from '../client'
import type {
  ApiResponse,
  PaginatedResponse,
  Folder,
  FolderListItem,
  CreateFolder,
  UpdateFolder,
  FolderSearchParams,
  PaginationParams
} from '../types'

export const folderService = {
  // Create a new folder
  createFolder: async (data: CreateFolder): Promise<ApiResponse<Folder>> => {
    return await post<ApiResponse<Folder>>(
      'folders/admin/private',
      data
    )
  },

  // Update an existing folder
  updateFolder: async (
    folderId: string,
    data: UpdateFolder
  ): Promise<ApiResponse<null>> => {
    return await put<ApiResponse<null>>(
      `folders/admin/private/${folderId}`,
      data
    )
  },

  // Delete a folder
  deleteFolder: async (folderId: string): Promise<ApiResponse<null>> => {
    return await del<ApiResponse<null>>(
      `folders/admin/private/${folderId}`
    )
  },

  // Get paginated list of private folders
  getFolders: async (
    params: PaginationParams = { page: 1, size: 10 }
  ): Promise<ApiResponse<PaginatedResponse<FolderListItem>>> => {
    return await get<ApiResponse<PaginatedResponse<FolderListItem>>>(
      `folders/private/paginated?page=${params.page}&size=${params.size}`
    )
  },

  // Get folder by ID
  getFolderById: async (folderId: string): Promise<ApiResponse<FolderListItem>> => {
    return await get<ApiResponse<FolderListItem>>(
      `folders/private/${folderId}`
    )
  },

  // Search folders by name
  searchFolders: async (
    params: FolderSearchParams
  ): Promise<ApiResponse<PaginatedResponse<Folder>>> => {
    const queryParams = new URLSearchParams({
      ...(params.searchBy && { searchBy: params.searchBy }),
      size: String(params.size || 10),
      page: String(params.page || 1)
    })

    return await get<ApiResponse<PaginatedResponse<Folder>>>(
      `folders/private/search?${queryParams}`
    )
  }
}
